module.exports = __webpack_public_path__ + "img/body-1-lg.73f83a82.png";